// Tier 6 Vastu proxy client.
// The frontend talks ONLY to these endpoints. To migrate the backend from
// FastAPI → Cloudflare Worker, swap `VASTU_PROXY_URL` and nothing else.
const VASTU_PROXY_URL = process.env.REACT_APP_VASTU_PROXY_URL
    || `${process.env.REACT_APP_BACKEND_URL}/api/vastu`;

export const MAX_UPLOAD_BYTES = 8 * 1024 * 1024;
export const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

export async function extractFromImage(file) {
    if (!ALLOWED_TYPES.includes(file.type)) {
        throw new Error(`Unsupported file type ${file.type}. Use PNG, JPG or PDF.`);
    }
    if (file.size > MAX_UPLOAD_BYTES) {
        throw new Error(`File exceeds ${Math.round(MAX_UPLOAD_BYTES / 1024 / 1024)} MB limit.`);
    }
    const form = new FormData();
    form.append("image", file);
    const res = await fetch(`${VASTU_PROXY_URL}/extract`, { method: "POST", body: form });
    if (!res.ok) {
        const t = await res.text();
        throw new Error(parseHttpError(t, res.status));
    }
    return res.json();
}

export async function extractFromText(text) {
    if (!text || !text.trim()) throw new Error("Enter at least a short description.");
    const form = new FormData();
    form.append("text", text.trim());
    const res = await fetch(`${VASTU_PROXY_URL}/extract`, { method: "POST", body: form });
    if (!res.ok) {
        const t = await res.text();
        throw new Error(parseHttpError(t, res.status));
    }
    return res.json();
}

export async function scoreConfirmedPlan({ session_id, extracted_plan, user_edited, original_extraction }) {
    const res = await fetch(`${VASTU_PROXY_URL}/score`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id, extracted_plan, user_edited, original_extraction }),
    });
    if (!res.ok) {
        const t = await res.text();
        throw new Error(parseHttpError(t, res.status));
    }
    return res.json();
}

function parseHttpError(body, status) {
    try {
        const j = JSON.parse(body);
        return j.detail || j.message || `Request failed (${status}).`;
    } catch {
        return body || `Request failed (${status}).`;
    }
}
